import React, { Fragment } from 'react'
import {
  SpacerVertical,
  Typography,
} from '@klarna/bubble-ui'
import styles from './PaymentMethod.css'

type PaymentMethodProps = {
  purchaseAmount: string
  badge: string
  backgroundColorKey: string
  installmentAmount?: string
  frequencyTitle?: string
  isSubscriptionOrAddToWallet?: boolean
};

const PaymentMethod: React.FC<PaymentMethodProps> = ({
  badge,
  frequencyTitle,
  purchaseAmount,
  installmentAmount = '',
  isSubscriptionOrAddToWallet = false
}) => (
  <Fragment>
    <style>{styles}</style>
    <div className="payment-method-container">
      <div id='left-content'>
        <Typography textToken="text-style/text/paragraphs/default/regular" colorToken="colors/text/subtle">
          {badge}
        </Typography>
        <SpacerVertical spaceToken="space.50" />
        <Typography textToken="text-style/text/labels/body/bold">
          {!isSubscriptionOrAddToWallet ? installmentAmount || purchaseAmount : ' '} {frequencyTitle}
        </Typography>
      </div>
    </div>
  </Fragment>
)

export default PaymentMethod
